/**
 * Accessibility Fixes — thefrenchsimracer.com
 * Corrige les problèmes ARIA du carrousel Slick, du widget Instafeed,
 * et des liens de marques.
 */
(function () {
  "use strict";

  /* ------------------------------------------------------------------ */
  /*  1.  SLICK SLIDER – correction complète des rôles et attributs     */
  /* ------------------------------------------------------------------ */
  function fixSlickAria() {
    var slideshow = document.querySelector(".slideshow.slick-initialized");
    if (!slideshow) return;

    /* — slick-track : remplacer role="listbox" par un rôle neutre — */
    var track = slideshow.querySelector(".slick-track");
    if (track) {
      track.removeAttribute("role");
      track.setAttribute("aria-label", "Diaporama de bannières promotionnelles");
      track.setAttribute("role", "group");
    }

    /* — Chaque slide (role="option") → role="group" + aria-label — */
    var slides = slideshow.querySelectorAll(".slick-slide:not(.slick-cloned)");
    slides.forEach(function (slide, i) {
      slide.setAttribute("role", "group");
      slide.setAttribute("aria-roledescription", "diapositive");
      slide.setAttribute("aria-label", "Diapositive " + (i + 1) + " sur " + slides.length);
      /* Les slides masquées : aria-hidden reste géré par Slick, mais on
         s'assure que les liens internes ne sont pas focusables */
      var isActive = slide.classList.contains("slick-active");
      var focusables = slide.querySelectorAll("a, button, input, [tabindex]");
      focusables.forEach(function (el) {
        el.setAttribute("tabindex", isActive ? "0" : "-1");
      });
    });

    /* — slick-dots : corriger tablist / tab / presentation — */
    var dots = slideshow.querySelector("ul.slick-dots");
    if (dots) {
      dots.setAttribute("role", "tablist");
      dots.setAttribute("aria-label", "Navigation du diaporama");

      var dotItems = dots.querySelectorAll("li");
      dotItems.forEach(function (li, i) {
        /* Rôle tab au lieu de presentation */
        li.setAttribute("role", "tab");
        li.setAttribute("aria-label", "Aller à la diapositive " + (i + 1));
        li.setAttribute("aria-selected", li.classList.contains("slick-active") ? "true" : "false");

        /* Supprimer aria-hidden sur les li (c'est invalide sur un tab) */
        li.removeAttribute("aria-hidden");
        /* aria-controls invalide (référence un id inexistant) → retirer */
        li.removeAttribute("aria-controls");

        /* Le bouton interne est redondant avec le rôle tab,
           on le rend non-focusable pour éviter le double focus */
        var btn = li.querySelector("button");
        if (btn) {
          btn.setAttribute("tabindex", "-1");
          btn.setAttribute("aria-hidden", "true");
        }
      });
    }
  }

  /* Ré-appliquer les fixes après chaque changement de slide */
  function observeSlickChanges() {
    var slideshow = document.querySelector(".slideshow.slick-initialized");
    if (!slideshow) return;

    var observer = new MutationObserver(function () {
      fixSlickAria();
    });

    var track = slideshow.querySelector(".slick-track");
    if (track) {
      observer.observe(track, { attributes: true, subtree: true, attributeFilter: ["class", "aria-hidden"] });
    }
    var dots = slideshow.querySelector(".slick-dots");
    if (dots) {
      observer.observe(dots, { attributes: true, subtree: true, attributeFilter: ["class"] });
    }
  }

  /* ------------------------------------------------------------------ */
  /*  2.  INSTAFEED – ajouter role="button" sur les divs                */
  /* ------------------------------------------------------------------ */
  function fixInstafeed() {
    var items = document.querySelectorAll("[data-instafeed-role-button]");
    items.forEach(function (el) {
      /* Ajouter le rôle button pour que aria-haspopup soit autorisé */
      if (!el.getAttribute("role")) {
        el.setAttribute("role", "button");
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  3.  BRAND SLIDER – corriger les aria-label génériques             */
  /* ------------------------------------------------------------------ */
  function fixBrandAriaLabels() {
    var brandLinks = document.querySelectorAll("a.adaptive_height[aria-label]");
    brandLinks.forEach(function (link) {
      /* Extraire le nom de la marque depuis le texte frère ou le href */
      var textEl = link.closest(".wrapper-content, .block-item")?.querySelector(".text, .brand-title, h3, h4, .title");
      var brandName = "";

      if (textEl) {
        brandName = textEl.textContent.trim();
      }

      if (!brandName) {
        /* Essayer d'extraire depuis l'URL */
        var href = link.getAttribute("href") || "";
        var match = href.match(/\/collections\/([^?#]+)/);
        if (match) {
          brandName = match[1].replace(/-/g, " ").replace(/\b\w/g, function (c) {
            return c.toUpperCase();
          });
        } else if (href.includes("youtube.com")) {
          var chanMatch = href.match(/@(.+)/);
          brandName = chanMatch ? "Chaîne YouTube " + chanMatch[1] : "Chaîne YouTube";
        }
      }

      if (brandName) {
        link.setAttribute("aria-label", brandName);
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  4.  SLIDE IMAGES – ajouter aria-label aux liens du carrousel      */
  /* ------------------------------------------------------------------ */
  function fixSlideImageLinks() {
    var slideLinks = document.querySelectorAll("a.slide-image");
    slideLinks.forEach(function (link) {
      if (!link.getAttribute("aria-label")) {
        var href = link.getAttribute("href") || "";
        var match = href.match(/\/collections\/([^?#]+)/);
        if (match) {
          var name = match[1].replace(/-/g, " ").replace(/\b\w/g, function (c) {
            return c.toUpperCase();
          });
          link.setAttribute("aria-label", "Voir la collection " + name);
        }
      }
      /* Corriger aussi l'alt vide des images */
      var img = link.querySelector("img");
      if (img && !img.getAttribute("alt")) {
        var ariaLabel = link.getAttribute("aria-label");
        if (ariaLabel) {
          img.setAttribute("alt", ariaLabel);
        }
      }
    });
  }

  /* ------------------------------------------------------------------ */
  /*  5.  ÉLÉMENTS STATIQUES (présents au chargement)                    */
  /* ------------------------------------------------------------------ */
  function fixStaticA11y() {
    /* #4 — SVG de recherche role="img" sans nom accessible */
    document.querySelectorAll('svg.icon-search').forEach(function (svg) {
      if (svg.getAttribute("role") === "img" && !svg.getAttribute("aria-label") && !svg.querySelector("title")) {
        svg.setAttribute("aria-label", "Rechercher");
      }
    });

    /* #5 — Bouton newsletter : le nom accessible doit inclure le texte visible.
       Un aria-label divergent masque le texte → on le retire pour que le texte
       visible devienne le nom accessible. */
    document.querySelectorAll("button.newsletter-form__button").forEach(function (btn) {
      var visible = (btn.textContent || "").trim();
      var al = btn.getAttribute("aria-label");
      if (visible && al && al.indexOf(visible) === -1) {
        btn.removeAttribute("aria-label");
      }
    });

    /* #6 — Le titre "catégories" est un <h3> qui casse l'ordre des titres.
       Ce n'est pas un vrai titre de document → on le neutralise sémantiquement. */
    document.querySelectorAll(".categories-title h3.title, .vertical-menu h3.title").forEach(function (h) {
      h.setAttribute("role", "presentation");
    });

    /* #7 — H1 logo en double (header principal + header sticky/mobile) :
       une page ne doit avoir qu'un seul H1. On garde le premier H1 visible
       et on neutralise les autres (ils ne contiennent que le logo). */
    var logoH1s = document.querySelectorAll("h1.header__heading");
    if (logoH1s.length > 1) {
      var kept = false;
      logoH1s.forEach(function (h) {
        var visible = h.offsetParent !== null;
        if (visible && !kept) {
          h.removeAttribute("role");
          kept = true;
        } else {
          h.setAttribute("role", "presentation");
        }
      });
      if (!kept) { logoH1s[0].removeAttribute("role"); }
    }

    /* #8 — Titres de popups cachés qui polluent le plan de titres de
       TOUTES les pages : deux <h2>Options</h2> (popup list-view + popup carte
       mobile) et un <h5> vide. Ce sont des libellés de modale, pas des titres
       de document → on les sort du plan de titres. */
    document.querySelectorAll("#list-view-popup h2, #halo-card-mobile-popup h2").forEach(function (h) {
      h.setAttribute("role", "presentation");
    });

    /* Neutraliser tout titre VIDE (ex. <h5 class="halo-popup-title"> vide),
       sauf les H1 logo qui sont nommés par l'alt de leur image. */
    document.querySelectorAll("h1, h2, h3, h4, h5, h6").forEach(function (h) {
      var hasText = (h.textContent || "").trim().length > 0;
      var namedImg = h.querySelector('img[alt]:not([alt=""])');
      if (!hasText && !namedImg && !h.classList.contains("header__heading")) {
        h.setAttribute("role", "presentation");
      }
    });

    /* #9 — Carrousels SECONDAIRES (hors slideshow principal) : leur .slick-track
       garde role="listbox" sans nom accessible. On le neutralise partout. */
    document.querySelectorAll('.slick-track[role="listbox"]').forEach(function (t) {
      t.removeAttribute("role");
      if (!t.getAttribute("aria-label")) {
        t.setAttribute("aria-label", "Carrousel");
      }
      t.setAttribute("role", "group");
    });

    /* #10 — Cibles tactiles trop petites (mobile) : agrandir la zone cliquable
       des liens texte des marques (brand slider). display:block garde le centrage
       du thème. Injecté une seule fois. */
    if (!document.getElementById("a11y-touch-target-style")) {
      var st = document.createElement("style");
      st.id = "a11y-touch-target-style";
      st.textContent = "@media (max-width:749px){.halo-row .wrapper-content a.text,.brand-slider a.text{display:block;min-height:24px;padding:8px 6px;line-height:1.5}}";
      (document.head || document.documentElement).appendChild(st);
    }
  }

  /* ------------------------------------------------------------------ */
  /*  INITIALISATION                                                     */
  /* ------------------------------------------------------------------ */
  function init() {
    fixStaticA11y();
    fixSlickAria();
    observeSlickChanges();
    fixInstafeed();
    fixBrandAriaLabels();
    fixSlideImageLinks();
  }

  /* Les éléments statiques sont corrigés tout de suite ; les éléments
     dynamiques (Slick/Instafeed) après leur initialisation différée. */
  function boot() {
    fixStaticA11y();
    setTimeout(init, 1500);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }

  /* Filet de sécurité : ré-exécuter après chargement complet */
  window.addEventListener("load", function () {
    setTimeout(init, 2500);
  });
})();
